export const TRACKING_EVENTS = {
  logged_in_load: 'Logged in page load',
  user_marketing_selected: 'User marketing selected',
  user_registered: 'User registered'
};

export const TRACKER_DISABLED = 'Tracker disabled';
